import React, { PureComponent, ReactNode } from 'react';
import { Row, Col } from 'react-bootstrap';
import PermitLinkWithColor from '../../components/PermitBlocks/PermitLinkWithColor';
import ContentSubheader from '../Layout/Partials/Content/ContentSubheader';
import PermitLink from '../../components/PermitBlocks/PermitLink';
import NeedHelp from '../../components/NeedHelp';
import IndexPublicStats from '../../components/IndexPublicStats';
import { Permits, IPermit, Articles, IArticle } from '../../StrapiService';
import {
  EnumPermitCategory,
  TPermitCategoryKeys,
  permitTitleByType,
} from '../permitsStatic';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

interface Props {
  locale: string;
  t: TFunction;
}

interface State {
  permits: IPermit[];
  articles: IArticle[];
  filterPermitsCategory?: TPermitCategoryKeys;
}
class HomePageAuthorizedPC extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      permits: [],
      articles: [],
    };
  }
  get permitsUsedMostlyFishing() {
    return this.state.permits.filter(
      (p) => p.usedMostly === EnumPermitCategory.fishing
    );
  }
  get permitsUsedMostlyForests() {
    return this.state.permits.filter(
      (p) => p.usedMostly === EnumPermitCategory.forests
    );
  }
  get permitsUsedMostly() {
    return this.state.permits
      .filter((p) => p.usedMostly !== undefined)
      .sort((a, b) => {
        const aPriority = a.usedMostlyPriority ? a.usedMostlyPriority : 0;
        const bPriority = b.usedMostlyPriority ? b.usedMostlyPriority : 0;
        return bPriority - aPriority;
      });
  }
  get permitsIfFiltered() {
    return this.state.permits.filter(
      (p) => p.category === this.state.filterPermitsCategory
    );
  }
  get permitsOther() {
    return this.state.permits.filter(
      (p) => !p.usedMostly && p.permitId !== 'L08.2'
    );
  }
  get howManyBlocks() {
    if (this.state.filterPermitsCategory) {
      return this.permitsIfFiltered.length % 2 !== 0 ? 6 : 12;
    }
    return this.permitsOther.length % 2 !== 0 ? 6 : 12;
  }
  filterBy(permitCategory?: TPermitCategoryKeys) {
    this.setState({
      filterPermitsCategory: permitCategory,
    });
  }
  async componentDidMount() {
    this.setState({
      permits: await Permits.getPermits(this.props.locale),
      articles: await Articles.getLatestArticles(3),
    });
  }
  render(): ReactNode {
    return (
      <>
        {!this.state.filterPermitsCategory && (
          <>
            {/* {
              this.permitsUsedMostlyFishing.length &&
              <ContentSubheader title="Mėgėjiška žvejyba" filterBy={this.filterBy.bind(this)} />
            }
            <Row>
              {
                this.permitsUsedMostlyFishing.map((p, i) => (
                  <Col key={`permit-mostly-used-${i}`} sm="12" md="6" lg="4" className="mb-4">
                    <PermitLinkWithColor permit={p} />
                  </Col>
                ))
              }
              {
                this.permitsUsedMostlyForests.length > 0 &&
                <Col xs="12" className="d-md-none d-lg-none d-xl-block">
                  <ContentSubheader title="Augalija, gyvūnija, miškai" />
                </Col>
              }
              {
                this.permitsUsedMostlyForests.map((p, i) => (
                  <Col key={`permit-mostly-used-${i}`} sm="12" md="6" lg="4" className="mb-4">
                    <PermitLinkWithColor permit={p} />
                  </Col>
                ))
              }
            </Row> */}
            {this.permitsUsedMostly.length > 0 && (
              <ContentSubheader
                title={this.props.t('home.public.topPermits')}
                filterBy={this.filterBy.bind(this)}
              />
            )}
            <Row>
              {this.permitsUsedMostly.map((p, i) => (
                <Col
                  key={`permit-mostly-used-${i}`}
                  sm='12'
                  md='6'
                  lg='6'
                  xl='4'
                  className='mb-4'
                >
                  <PermitLinkWithColor permit={p} />
                </Col>
              ))}
            </Row>
          </>
        )}
        {!this.state.filterPermitsCategory && (
          <ContentSubheader title={this.props.t('home.public.otherPermits')} />
        )}
        {this.state.filterPermitsCategory && (
          <ContentSubheader
            title={permitTitleByType(this.state.filterPermitsCategory)}
            filterBy={this.filterBy.bind(this)}
            showRemoveFilter={true}
          />
        )}
        <Row>
          {this.state.filterPermitsCategory &&
            this.permitsIfFiltered.map((p, i) => (
              <Col key={`permits-filtered-${i}`} lg='6'>
                <PermitLink permit={p} t={this.props.t} />
              </Col>
            ))}
          {!this.state.filterPermitsCategory &&
            this.permitsOther.map((p, i) => (
              <Col key={`permits-other-${i}`} lg='6'>
                <PermitLink permit={p} t={this.props.t} />
              </Col>
            ))}
          <Col lg={this.howManyBlocks} className='mb-4'>
            <NeedHelp
              style={{ height: '100%' }}
              content={this.props.t('home.public.needHelp')}
              t={this.props.t}
            />
          </Col>
        </Row>
        {this.state.permits.length > 0 && (
          <>
            <ContentSubheader title={this.props.t('home.public.publicInfo')} />
            <IndexPublicStats permits={this.state.permits} t={this.props.t} />
          </>
        )}
      </>
    );
  }
}

export const HomePageAuthorized: React.FC<{}> = () => {
  const { t, i18n } = useTranslation();

  return <HomePageAuthorizedPC locale={i18n.language} t={t} />;
};

export default HomePageAuthorized;
